export var footerLinksSpanish = [
    {
      // Personal Banking,
      title: "Banca Personal",
      id: "sml-personal-banking",
      url: "/es",
      links: [
        {
          // Checking
          id: "sml-pb-checking-account",
          show: true,
          text: "Cuenta de Cheques",
          url: "/es/banca-personal/cuenta-de-cheques"
        },
        {
          // Savings, CDs & Money Markets
          id: "sml-pb-savings-cd-mm",
          show: true,
          text: "Cuentas de Ahorro, Cuentas a Plazo Fijo (CD) y Cuentas de Money Market",
          url: "/es/banca-personal/cuentas-de-ahorro"
        },
        {
          // Retirement Savings (IRA)
          id: "sml-pb-ira-accounts",
          show: false,
          text: "Cuentas Individuales de Retiro o Jubilacion (IRA)",
          url: "/es/banca-personal/jubilacion-ira"
        },
        {
          // Credit Cards
          id: "sml-pb-credit-cards",
          show: true,
          text: "Tarjetas de Credito",
          url: "/es/banca-personal/tarjetas-de-credito"
        },
        {
          // Fees
          id: "sml-pb-account-fees",
          show: true,
          text: "Cargos",
          url: "/es/banca-personal/cargos"
        },
        {
          // Disclosures
          id: "sml-pb-account-details",
          show: true,
          text: "Detalles de la Cuenta",
          url: "/es/detalles-de-la-cuenta"
        },
        {
          // Personal Account Sign In
          id: "sml-pb-personal-account-login",
          show: true,
          text: "Iniciar Sesion en una Cuenta Personal",
          url: "/es/banca-personal/entrar"
        }
      ]
    },
    {
      // Home Loans
      title: "Prestamos Hipotecarios",
      id: "sml-home-loans",
      url: "/es/banca-personal/prestamos-hipotecarios",
      links: [
        {
          // Apply for a Loan
          id: "sml-hl-apply-online",
          show: true,
          text: "Contacte a un Asesor Hipotecario",
          url: "/es/banca-personal/contacte-a-un-asesor-hipotecario"
        },
        {
          // Homeowner Assistance
          id: "sml-hl-homeowner-assistance",
          show: true,
          text: "Asistencia al Propietario",
          url: "/es/banca-personal/prestamos-hipotecarios/asistencia-a-propietarios"
        }
      ]
    }
  ],
  socialLinksSpanish = [
    {
      // Facebook
      id: "fl-facebook-link",
      show: true,
      url: "https://www.facebook.com/wafdbank",
      icon: {
        lib: "fab",
        name: "facebook-f",
        class: "text-white fa-lg"
      }
    },
    {
      // Twitter
      id: "fl-twitter-link",
      show: true,
      url: "https://www.twitter.com/wafdbank",
      icon: {
        lib: "fab",
        name: "twitter",
        class: "text-white fa-lg"
      }
    },
    {
      // LinkedIn
      id: "fl-linked-in-link",
      show: true,
      url: "https://www.linkedin.com/company/wafd-bank/",
      icon: {
        lib: "fab",
        name: "linkedin-in",
        class: "text-white fa-lg"
      }
    },
    {
      // YouTube
      id: "fl-youtube-link",
      show: true,
      url: "https://www.youtube.com/user/wafedweb",
      icon: {
        lib: "fab",
        name: "youtube",
        class: "text-white fa-lg"
      }
    },
    {
      // InstaGram
      id: "fl-instagram-link",
      show: true,
      url: "https://www.instagram.com/wafdbank/",
      icon: {
        lib: "fab",
        name: "instagram",
        class: "text-white fa-lg"
      }
    }
  ],
  aboutUsLinksSpanish = [
    {
      // About Us
      id: "mm-ab-about",
      show: false,
      class: "",
      textMobile: "About Us",
      text: "About WaFd Bank",
      url: "/about-us"
    },
    {
      // FAQs
      id: "mm-ab-faqs",
      show: true,
      class: "ml-3",
      text: "Pregunatas Frecuentes",
      url: "/es/preguntas-frecuentes"
    },
    {
      // Contact Us
      id: "mm-ab-contact-us",
      show: true,
      class: "ml-3",
      text: "Contactanos",
      url: "/es/contactanos"
    }
  ];
